/**
 * Utility functions extracted from TreemapChart.tsx
 */

export const COLORS = [
  "#90EE90", // bright green
  "#4B9CD3", // medium blue
  "#FFE66D", // bright yellow
  "#9B5DE5", // bright purple
  "#45B7D1", // cyan
  "#7DCEA0", // sage green
  "#738ADB", // periwinkle blue
  "#50C878", // emerald green
  "#48D1CC", // turquoise
  "#E6E6FA", // light purple
  "#98FB98", // pale green
  "#87CEEB", // sky blue
  "#DDA0DD", // plum
];

/**
 * Capitalize first letter and replace _ with space
 */
export function formatCategoryName(name: string): string {
  return name.charAt(0).toUpperCase() + name.slice(1).replace("_", " ");
}

/**
 * Lowercase and replace space with _
 */
export function categoryNameToKey(name: string): string {
  return name.toLowerCase().replace(" ", "_");
}

/**
 * Build treemap data from content record
 */
export function buildTreemapData(
  content: Record<string, number>
): { name: string; size: number }[] {
  return Object.entries(content).map(([name, size]) => ({
    name: name.charAt(0).toUpperCase() + name.slice(1).replace("_", " "),
    size,
  }));
}

/**
 * Get color for a category based on its position in the children array
 */
export function getColorForCategory(
  categoryName: string,
  children: Array<{ name: string }>
): string {
  const colorIndex = children.findIndex((child) => child.name === categoryName);
  return colorIndex >= 0 ? COLORS[colorIndex] : COLORS[0];
}

/**
 * Determine if a label should be shown based on cell dimensions
 */
export function shouldShowLabel(width: number, height: number): boolean {
  return width > 50 && height > 30;
}
